import { Legal } from 'models';

export class LegalSource {
  private legal: object;

  public constructor(legal: object) {
    this.legal = legal;
  }

  public getConfig(siteId: number): Legal {
    if (this.legal && siteId in this.legal) {
      return this.legal[siteId];
    } else {
      return { address: '', email: '', supportLink: '', privacyPolicyLink: '' };
    }
  }
}
